import { Injectable } from "@angular/core";

import { BaseDataSource } from "../shared/_base.datasource";
import { Observable } from "rxjs";
import { Country } from "../../types/country/country.type";
import { CountryService } from "../../../services/country/country.service";

@Injectable()
export class CountryDatasource extends BaseDataSource<Country> {
    constructor(private service: CountryService) {
        super(service);
    }

    create(data: Country): Observable<boolean> {
        return this.service.create(data);
    }

    delete(id: number): Observable<boolean> {
        return this.service.delete(id);
    }

    update(data: Country): Observable<boolean> {
        return this.service.update(data);
    }

    getList() {
        const self = this;

        if (!self.service) {
            return;
        }

        self.loading = true;

        self.service.getList(self.filter).subscribe((res) => {
            self.rows = res.rows;
            self.count = res.count;
            self.loading = false;
        });
    }

    getListInside() {
        const self = this;

        if (!self.service) {
            return;
        }

        self.loading = true;

        return self.service.getList(self.filter);
    }
}
